'use client';

import { useMediaQuery, useTheme } from '@mui/material';

export function useResponsiveBreakpoints() {
	const theme = useTheme();
	const m = useMediaQuery(theme.breakpoints.down('md'));
	const ts = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
	const tb = useMediaQuery(theme.breakpoints.between('md', 'xl'));
	const d = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
	const dl = useMediaQuery(theme.breakpoints.up('xl'));

	return {
		extraSmall: m && !ts && !tb && !d && !dl,
		small: m && ts && !tb && !d && !dl,
		medium: !m && ts && tb && !d && !dl,
		large: !m && !ts && tb && d && !dl,
		extraLarge: d,
	};
}
